import { render } from "./ChartView.vue?vue&type=template&id=1245fdd0"
import script from "./ChartView.vue?vue&type=script&lang=js"
export * from "./ChartView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__